import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Leaderboard from '@components/leaderboard/Leaderboard';
import {
  setNavbarWithTitleNoTopNavbar,
  resetToDefaultNavbarState,
  haveBottomNavbar,
} from '@atom/navbarAtom';
import { useStore } from 'jotai';

const LeaderboardDashboardPage = () => {
  const store = useStore();

  useEffect(() => {
    store.set(haveBottomNavbar, false);
    setNavbarWithTitleNoTopNavbar('Leaderboard');

    return () => {
      resetToDefaultNavbarState();
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Geniebook - Leaderboard</title>
        <meta name="description" content="Leaderboard" />
      </Helmet>
      <Leaderboard />
    </>
  );
};

export default LeaderboardDashboardPage;
